import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { StoreProvider } from "@/context/StoreContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Communities from "@/pages/Communities";
import CommunityDetail from "@/pages/CommunityDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Join from "@/pages/Join";
import GroupApply from "@/pages/GroupApply";
import Prayer from "@/pages/Prayer";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import School from "@/pages/School";
import CourseDetail from "@/pages/CourseDetail";
import Certificate from "@/pages/Certificate";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MyTerco from "@/pages/MyTerco";
import Store from "@/pages/Store";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import Materials from "@/pages/Materials";
import AuthCallback from "@/pages/AuthCallback";

function Protected({ children, adminOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-th-blue">...</div>;
  if (!user) return <Navigate to="/entrar" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/o-meu-terco" replace />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <StoreProvider>
          <CartProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/quem-somos" element={<About />} />
                  <Route path="/comunidades" element={<Communities />} />
                  <Route path="/comunidades/:id" element={<CommunityDetail />} />
                  <Route path="/eventos" element={<Events />} />
                  <Route path="/eventos/:id" element={<EventDetail />} />
                  <Route path="/aderir" element={<Join />} />
                  <Route path="/candidatar-grupo" element={<GroupApply />} />
                  <Route path="/rosario-pela-paz" element={<Prayer />} />
                  <Route path="/noticias" element={<News />} />
                  <Route path="/noticias/:id" element={<NewsDetail />} />
                  <Route path="/escola" element={<School />} />
                  <Route path="/escola/:id" element={<CourseDetail />} />
                  <Route path="/escola/:id/certificado" element={<Certificate />} />
                  <Route path="/entrar" element={<Login />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/registar" element={<Register />} />
                  <Route path="/recuperar-palavra-passe" element={<ForgotPassword />} />
                  <Route path="/redefinir-palavra-passe" element={<ResetPassword />} />
                  <Route path="/loja" element={<Store />} />
                  <Route path="/loja/carrinho" element={<Cart />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/o-meu-terco" element={<Protected><MyTerco /></Protected>} />
                  <Route path="/materiais" element={<Protected><Materials /></Protected>} />
                  <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
              <Toaster position="top-center" richColors />
            </BrowserRouter>
          </CartProvider>
        </StoreProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
